import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { CustomerInfo } from '../../models/customer-info';
import { ProjectStatus, TeamAssist } from '../../models/org-status';
import { IMToolService } from '../../services/im-tool.service';
import { AlertWizardComponent } from '../alert-wizard/alert-wizard.component';
import * as constants from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { ImportWizardComponent } from '../import-wizard/import-wizard.component';
import { FormControl } from '@angular/forms';
import { DropDownTwo } from 'src/app/internal-user/drug-management/models/dropdown';
import { EMPTY, Subject, switchMap, takeUntil, timer } from 'rxjs';

@Component({
    selector: "app-pm-customer-management",
    templateUrl: "./pm-customer-management.component.html",
    styleUrls: ["./pm-customer-management.component.scss"],
    standalone: false
})
export class PmCustomerManagementComponent implements OnInit, OnDestroy {
  customers: CustomerInfo[] = [];
  dataSource = new MatTableDataSource<CustomerInfo>();
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;



  displayedColumns: string[] = [
    "sl",
    "customerName",
    "caseNumber",
    "customerNumber",
    "subDeviceTypeName",
    "lastEdited",
    "statusDescription",
    "targetInstallDate",
    "owner",
    // "assetProductLine",
    "action",
  ];
  projectStatus: ProjectStatus[] = [];
  teamAssists: TeamAssist[] = [];
  customerData: CustomerInfo[] = [];
  salesforceStatusList:DropDownTwo[]= [];
  salesforceStatus:FormControl = new FormControl('');
  selected: string = "1";
  selectedProjectStatus : number = 0;
  selectedTeamAssists: number = 1;
  selectedProduct : string = 'All';
  searchCriteria = [
    { value: 'customerName', label: 'Customer Name' },
    { value: 'caseNumber', label: 'Case Number', pattern: /^\d+$/, errorMsg: 'Case Number must contain only numbers' },
    { value: 'customerNumber', label: 'Customer Number', pattern: /^\d+$/, errorMsg: 'Customer Number must contain only numbers' },
    { value: 'assetNumber', label: 'Asset Number', pattern: /^\d+$/, errorMsg: 'Asset Number must contain only numbers' },
  ];
  selectedSearchCriteria = this.searchCriteria[0];
  validationError = '';
  //#region Pagination properties
  totalRows: number = 0;
  currentPage: number = 0;
  pageSize: number = 50;
  pageSizeOptions: number[] = [50, 100, 200, 500];
  Products = ['MAX', 'Pass', 'ATP', 'Mini', 'Synmed', 'ATP(CAPS)', 'Legacy Connect', 'All'];
  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getCustomerData();
  }
  //#endregion

  //#region Sorting Properties
    sortDir:string="asc";
    sortColumnName:string="";
    @HostListener("matSortChange", ["$event"])
    sortChange(event) {
      this.sortColumnName = event.active;
      this.sortDir = event.direction;
      this.getCustomerData();
    }
    searchText: string="";
    statusId:number=0;
  private readonly searchSubject = new Subject<boolean>();
  private readonly destroy$ = new Subject<void>();
  //#endregion


  // Selected Row Color Change key
  selectedRow;

  @HostListener("window:resize")
  onResize() {
    if (window.innerWidth > 900) {
    }
  }
  constructor(
    private dialog: MatDialog,
    private imtoolService: IMToolService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private route: Router
  ) {}

  ngOnInit(): void {
    this.searchSubject
      .pipe(
        switchMap(shouldSearch => shouldSearch ? timer(700) : EMPTY),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.currentPage = 0;
        this.getCustomerData();
      });

    this.getCustomerData();
    this.getFileStatusData();
    this.getSalesForceStatus();
    this.teamAssists.push({
      id: 1,
      value: "Your Worklist",
    });


  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
  getCustomerData() {
    if (!this.validateSearchText()) {
      return;
    }

    const CUSTOMERDATA_KEY = 'Customerdatakey';
    this.ngxLoader.start(CUSTOMERDATA_KEY);
    this.imtoolService
      .getCustomerData(
        this.searchText,
        this.currentPage == 0 ? 1 : this.currentPage,
        this.pageSize,
        this.sortColumnName,
        this.sortDir,
        this.statusId,
        this.salesforceStatus.value.toString(),
        this.selectedProduct == null ? '':this.selectedProduct,
        this.selectedSearchCriteria.value
      )
      .subscribe(
        (result) => {
          let response = result.data;
          if(response == null){
            this.ngxLoader.stop(CUSTOMERDATA_KEY);
            this.toastService.openToast(
              response.message,
              constants.ToastPanelType.error,
              2
            );
            return
            } ;
          this.customers = [];
          if(response.data != null || response.data != undefined){
            response?.data.forEach((x) =>
            this.customers.push({
              sl:x.sl,
              customerId: x.id,
              assetProductLine:x.assetProductLine,
              customerName: x.customerName,
              caseNumber: x.caseNumber,
              caseDetailsLink: x.caseDetailsLink??"",
              customerNumber: x.customerNumber,
              assetNumber: x.assetNumber,
              deviceType: x.deviceType,
              lastEdited: x.modifiedDate,
              deviceId:x.deviceId,
              status: {
                id: x.status.id == undefined || x.status.id  == null ? 0: x.status.id,
                value: x.status.description == undefined  || x.status.description  == null? '': x.status.description,
              },
              subDeviceTypeName:
                x.deviceTypeName == null ? "" : x.deviceTypeName,
              statusDescription: x.status.description,
              targetInstallDate: x.targetInstallDate,
              owner: x.modifiedBy,
            })
          );

          }
          this.dataSource.data = this.customers;
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = response.totalRows;
          },0);
          this.ngxLoader.stop(CUSTOMERDATA_KEY);
        },

        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(CUSTOMERDATA_KEY);
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        }
      );
  }

  getFileStatusData(){
    const FILESTATUS_KEY = 'Filestatuskey'
    this.ngxLoader.start(FILESTATUS_KEY);
    this.imtoolService.getfileStatus().subscribe((result)=>{
    this.projectStatus = result.data;
    this.ngxLoader.stop(FILESTATUS_KEY);
    },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(FILESTATUS_KEY);
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        })
  }


  getSalesForceStatus(){
    const SALESFORCESTATUS_KEY = 'Salesforcesstatuskey'
    this.ngxLoader.start(SALESFORCESTATUS_KEY);
    this.imtoolService.getSalesForceStatus().subscribe((result)=>{
    this.salesforceStatusList = result.data;
    this.ngxLoader.stop(SALESFORCESTATUS_KEY);
    },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(SALESFORCESTATUS_KEY);
          console.log(error);
          this.toastService.openToast(
            error.error.message ?? error.message,
            constants.ToastPanelType.error,
            2
          );
        })
  }
  public doFilter = (value: any, isTextSearch:boolean, product:string = '') => {
    if(isTextSearch)
    {
     this.searchText = value;
    }
    else{
    this.statusId = value;
    }
    this.selectedProduct = product;
    this.currentPage = 0;
    this.getCustomerData();
  };

  applyCustomerFilters(): void {
    this.currentPage = 0;
    this.getCustomerData();
  }

  onSearchTextChange(value: string): void {
    this.searchText = value;
    this.validateSearchText();
    this.searchSubject.next(true);
  }

  onSearchCriteriaChange(value: string): void {
    this.selectedSearchCriteria = this.searchCriteria.find(criteria => criteria.value === value) ?? this.searchCriteria[0];
    this.validateSearchText();
    this.searchSubject.next(false);
  }

  private validateSearchText(): boolean {
    const value = this.searchText.trim();
    const criteria = this.selectedSearchCriteria;

    if (!value || !criteria.pattern || criteria.pattern.test(value)) {
      this.validationError = '';
      return true;
    }

    this.validationError = criteria.errorMsg ?? '';
    return false;
  }

  getRow(row: any) {
    this.customerData.push(row);
  }

  openAlertWindow(row: any) {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "Warning",
        bodyMessage: "Are you sure you want to remove?",
        bodyMessage2: "",
        cancelBtnText: "Go Back",
        confirmBtnText: "Continue",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.customerRemove(row.customerId);
      } else {
        console.log("Cancle", result);
      }
    });
  }

  customerRemove(customerId: string) {
    const CUSTOMERREMOVE_KEY = 'Customeremovekey'
    this.ngxLoader.start(CUSTOMERREMOVE_KEY);
    this.imtoolService.customerRemove(customerId).subscribe(
      (result) => {
        this.ngxLoader.stop(CUSTOMERREMOVE_KEY);
        if (result.statusCode == 200) {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.done,
            2
          );
          this.getCustomerData();
        } else {
          this.toastService.openToast(
            result.message,
            constants.ToastPanelType.error,
            2
          );
            this.ngxLoader.stop(CUSTOMERREMOVE_KEY)
        }
      },
      (error: HttpErrorResponse) => {
        this.ngxLoader.stop(CUSTOMERREMOVE_KEY);
        console.log(error);
        this.toastService.openToast(
          error.error.message ?? error.message,
          constants.ToastPanelType.error,
          2
        );
      }
    );
  }
  openAddSite(row: any) {
    const dialogSiteRef = this.dialog.open(ImportWizardComponent, {
      backdropClass: ['lgDialog'],
      disableClose: true,
      data: { customer: row },
    });
    dialogSiteRef.afterClosed().subscribe((result) => {
      this.getCustomerData();
    });
  }
  redirectPageBasedOnStatus(row: CustomerInfo) {
    if (row.status.id === 3 || row.status.id===5 || row.status.id === 4 || row.status.id === 6) {
      if(row?.deviceId===3){
        this.route.navigate(["/im-tool/atp-export", row.customerId]);
      }
      else if(row?.deviceId===2){
        this.route.navigate(["/im-tool/pass-export", row.customerId]);
      }
      else if(row?.deviceId===4){
        this.route.navigate(["/im-tool/synmed-export", row.customerId]);
      }
      else if(row?.deviceId===5){
        this.route.navigate(["/im-tool/mini-export", row.customerId]);
      }
      else if(row?.deviceId===6){
        this.route.navigate(["/im-tool/atp-caps-export", row.customerId]);
      }
      else if(row?.deviceId===7){
        this.route.navigate(["/im-tool/legacy-connect", row.customerId]);
      }
      else{
        this.route.navigate(["/im-tool/export", row.customerId]);
      }

    } else if (row.status.id === 1 || row.status.id === 2) {
      this.openAddSite(row);
    }
  }




}
